/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Button } from '@mui/material';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import DeviceCreation from './DeviceCreation';

const DeviceCreationBtn = () => {
    const [openDeviceCreationModal, setOpenDeviceCreationModal] = useState(false);
    const handleCloseDialog = () => {
        setOpenDeviceCreationModal(false)
    }
    return (
        <>
            <Button variant="contained" sx={{ background: (theme) => theme.palette.gradiant.main, float: 'right' }}
                onClick={() => setOpenDeviceCreationModal(true)}  >Register Device </Button>
            <DialogContainer
                open={openDeviceCreationModal}
                handleClose={handleCloseDialog}
            >
                <DeviceCreation handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default DeviceCreationBtn;
